import {getRequest, postRequest} from "./AxiosConfig";

export async function getProductPrices(){
    return await getRequest( "/product/prices");
}

export async function getProductTokenById(productId, setErrorMessage){
    return await getRequest( "/product/token/find/"+productId, setErrorMessage);
}

export async function getProductTokenByProductName(productName, setErrorMessage){
    if(productName.includes("_")) {
        productName = productName.replaceAll("_", "%20")
    }
    return await getRequest( `/product/token/find/name/${productName}`, setErrorMessage);
}

export async function getPreviewById(id, setErrorMessage){
    return await getRequest( "/product/preview/find/"+id, setErrorMessage);
}

export async function getProductByName(productName, setErrorMessage){
    if(productName.includes("_")) {
        productName = productName.replaceAll("_", " ")
    }
    return await getRequest( `/product/find/name/${productName}`, setErrorMessage);
}


export async function getAllPublicProducts(setErrorMessage){
    return await getRequest( "/product/store", setErrorMessage);
}

export async function getUserProducts(setErrorMessage) {
    return await getRequest( "/product/my_products", setErrorMessage);
}

export async function purchaseToken(id, setErrorMessage) {
    return await getRequest( "/payment/purchase/"+id, setErrorMessage);
}

export async function getPurchaseStatus(id, setErrorMessage) {
    return await getRequest( "/payment/purchase/status/"+id, setErrorMessage);
}

export async function getAgreementInfo(setErrorMessage) {
    return await getRequest( `/payment/agreement/info`, setErrorMessage);
}

export async function stopAgreement(setErrorMessage) {
    return await getRequest( "/payment/agreement/stop", setErrorMessage);
}

export async function getStopAgreementStatus(agreementId, setErrorMessage) {
    return await getRequest( `/payment/agreement/${agreementId}/stop/status`, setErrorMessage);
}

export async function getPossibleChangesForAgreement(setErrorMessage) {
    return await getRequest( "/payment/agreement/change/available", setErrorMessage);
}

export async function changeAgreementPlan(agreementId, tokenId, setErrorMessage) {
    return await postRequest( "/payment/agreement/"+agreementId+"/change/"+tokenId,setErrorMessage,{});
}

export async function changeAgreementPlanInfo(oldTokenId, newTokenId, setErrorMessage) {
    return await getRequest( `/payment/agreement/change/info/${oldTokenId}/${newTokenId}` ,setErrorMessage);
}

export async function getTestAgreementInfo(token) {
    return await getRequest(`/product/token/test/${token}`)
}

export async function testyPay(setErrorMessage) {
    return await getRequest( `/payment/test` ,setErrorMessage);
}

export async function activateTestAgreement(token, setErrorMessage) {
    return await getRequest( `/product/activate/${token}` ,setErrorMessage);
}

export async function bestTags() {
    return await getRequest(`/product/stats/tags/strength`)
}

export async function worstTags() {
    return await getRequest(`/product/stats/tags/improve`)
}
